import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MainLayoutComponent} from './shared/layouts/main-layout/main-layout.component';
import {NotFoundComponent} from './dashboard/components/not-found/not-found.component';


const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule),
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'news',
        loadChildren: () => import('./news/news.module').then(m => m.NewsModule),
      },
      {
        path: 'statements',
        loadChildren: () => import('./user-statements/user-statements.module').then(m => m.UserStatementsModule),
      },
      {
        path: 'payment-history',
        loadChildren: () => import('./traffic-packs-history/traffic-packs-history.module').then(m => m.TrafficPacksHistoryModule)
      },
      {
        path: 'traffic',
        loadChildren: () => import('./traffic-and-statistic/traffic-and-statistic.module').then(m => m.TrafficAndStatisticModule)
      },
    ]
  },
  {
    path: '**',
    component: NotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
